export default {
  WAITING_SHIPMENT_ORDER: {
    label: 'Aguardando Pedido',
    value: 'WAITING_SHIPMENT_ORDER',
  },
  WAITING_CTE: {
    label: 'Aguardando CTe',
    value: 'WAITING_CTE',
  },
  WAITING_CTE_VALIDATION: {
    label: 'Aguardando validação do CTe',
    value: 'WAITING_CTE_VALIDATION',
  },
  WAITING_SERVICE_FINALIZATION: {
    label: 'Aguardando finalização do serviço',
    value: 'WAITING_SERVICE_FINALIZATION',
  },
  WAITING_FOR_MARGIN_VALIDATION: {
    label: 'Aguardando validação da margem',
    value: 'WAITING_FOR_MARGIN_VALIDATION',
  },
  WAITING_FOR_CONCILIATION: {
    label: 'Aguardando conciliação',
    value: 'WAITING_FOR_CONCILIATION',
  },
  WAITING_APPROVAL: {
    label: 'Aguardando aprovação',
    value: 'WAITING_APPROVAL',
  },
  RECONCILIATION_DECLINED: {
    label: 'Conciliação recusada',
    value: 'RECONCILIATION_DECLINED',
  },
  RELEASED_FOR_PRE_INVOICE: {
    label: 'Liberado para pré-fatura',
    value: 'RELEASED_FOR_PRE_INVOICE',
  },
  WAITING_LOGISTIC_PROVIDER_VALIDATION: {
    label: 'Aguardando validação da Transportadora',
    value: 'WAITING_LOGISTIC_PROVIDER_VALIDATION',
  },
  WAITING_RELEASE_FOR_PAYMENT: {
    label: 'Aguardando liberação para pagamento',
    value: 'WAITING_RELEASE_FOR_PAYMENT',
  },
  AUTOMATICALLY_RELEASED: {
    label: 'Liberado automáticamente',
    value: 'AUTOMATICALLY_RELEASED',
  },
  GENERATING_PRE_INVOICE: {
    label: 'Gerando pré-fatura',
    value: 'GENERATING_PRE_INVOICE',
  },
  REQUEST_DECLINED: {
    label: 'Pedido recusado',
    value: 'REQUEST_DECLINED',
  },
  REQUEST_APPROVED: {
    label: 'Solicitação aprovada',
    value: 'REQUEST_APPROVED',
  },
  PAYMENT_APPROVED: {
    label: 'Pagamento aprovado',
    value: 'PAYMENT_APPROVED',
  },
  PAYMENT_DECLINED: {
    label: 'Pagamento recusado',
    value: 'PAYMENT_DECLINED',
  },
  PAID: {
    value: 'PAID',
    label: 'Pago',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/enums/EnumStatus.js